<template>
  <div class="home" @touchstart="handleTouchstart"  @touchend="handleTouchend">
    <van-overlay :show="show" />
    <van-overlay class="loginOverLay" :show="showLogin" />
    <div class="banner">
      <img src="../../assets/beijing.png">
    </div>
    <header>
      <div class="contentss">
        <div class="left">
          <div class="text">
            <h3>ICCID：</h3>
            <h3>{{ cardNum }}</h3>
            <div class="left_bottom">
              <div class="leftText texts">
                <div class="zt"><p>状态：</p></div>
                <div v-show="createdList.stateFlag===2" class="ztqk">
                  <i class="isWait"></i> <!-- 待激活 -->
                  <p>{{ createdList.status }}</p>
                </div>
                <div v-show="createdList.stateFlag===3" class="ztqk">
                  <i class="isOk"></i><!-- 已激活 -->
                  <p>{{ createdList.status }}</p>
                </div>
                <div v-show="createdList.stateFlag===4" class="ztqk">
                  <i class="isNo"></i><!-- 已停机 -->
                  <p>{{ createdList.status }}</p>
                </div>
                <div v-show="createdList.stateFlag===567" class="ztqk">
                  <i class="isOut"></i><!-- 其他 -->
                  <p>{{ createdList.status }}</p>
                </div>
              </div>
              <div class="rightText">
                <div class="syts"><p>剩余天数：{{ createdList.remainTime }}天</p></div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="right_ll">
            <span>{{ createdList.remainFlow }}</span>
            <span v-if="createdList.remainFlow" class="spanMB">MB</span>
          </div>
          <div class="right_text">剩余流量</div>
          <img src="../../assets/zs.png" />
        </div>
      </div>
    </header>
    <nav>
      <ul>
        <li>
          <p>激活日期：</p>
          <p class="time">{{ createdList.activeDate }}</p>
        </li>
        <li>
          <p>预计停机：</p>
          <p class="time">{{ createdList.offTime }}</p>
        </li>
      </ul>
    </nav>
    <div class="content">
      <h4 class="tc">套餐：{{ createdList.pkName }}</h4>
      <div class="idmain">
        <div id="main" :style="{ width: '100%', height: '100%' }"></div>
      </div>
      <h5>充值有延迟，充值后设备关机10分钟，再开机联网。<br />充值后异常，请点击【网络重置】或联系下方服务商</h5>
      <div class="nav">
        <div @click="switchcardNum" class="lis">
          <img src="../../assets/qiehuan.png">
          <h3>切换卡号</h3>
        </div>
        <div class="shu"></div>
        <div @click="refresh" class="lis">
          <img src="../../assets/shuaxin.png">
          <h3>网络重置</h3>
        </div>
        <div class="shu"></div>
        <!-- <div @click="updates" class="lis">
          <img src="../../assets/tixing.png">
          <h3>叠加当月流量</h3>
        </div> -->
        <div class="shu"></div>
        <div @click="tochongzhi" class="lis">
          <img src="../../assets/tixing.png">
          <h3>流量充值</h3>
        </div>
        </div>
    </div>
    <footer>
      <!-- <p>POS机服务商：{{ createdList.serviceName }}</p> -->
      <!-- <p>POS售后电话：{{ createdList.mobile }}</p> -->
    </footer>
    <div class="btnbox">
      <!-- <van-button  plain type="info" @click="recharge">点击 续费一年 <span>￥{{createdList.price}}</span> 元</van-button> -->
      <div class="shu" style="height: 0.2rem;"></div>
      <van-button  plain type="info" @click="tochongzhi">流量充值</van-button>
      <!-- <div class="shu" style="
          height: 0.9rem;
          font-size: 0.25rem;
          padding: 0 0.8rem;
          margin-top: 0.2rem;
          color: red">
        <span>* 在用的旧系统卡可以前往旧系统充值 也可以直接在新系统充值 后续旧系统会停用推荐使用新系统充值</span>
      </div>
      <van-button  plain type="info" @click="toold">前往旧的系统充值</van-button> -->
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { Toast } from 'vant'
import { initConfig, chooseWXPay } from '@/api/wxShare.js'
import { getAppEdition } from '@/api/login.js'
import * as api from '@/api/api.js'
import wx from 'weixin-js-sdk'

export default {
  name: 'Recharge',
  components: {},
  props: {},
  data () {
    return {
      // 卡号
      cardNum: '',
      // 卡号获取的初始内容
      createdList: {},
      // 折现图 x轴 坐标数据
      xAxisData: ['2020.10', '2020.11', '2020.12', '2021.01', '2021.02', '2021.03'],
      // 折现图 x轴 数据
      seriesData: [0, 0, 0, 0, 0, 0, 0],
      eqpId: '',
      openid: '',
      carrier: '',
      show: false,
      showLogin: false,
      myChart: null,
      flagIndex: 0,
      flag: false,
      times: '',
      type: '',
      czOrcx: '',
      thisURL: '',
      // 滑动
      startX: '',
      czIndex: 0,
      storeName: '',
      isFirst: false,
      // 对比不同的次数
      dbIndex: 0,
      // 对比不同的参数
      dbForm: {}
    }
  },
  watch: {
    flagIndex: function (res) {
      if (res === 3) {
        clearInterval(this.times)
        this.times = ''
        this.flag = true
        this.flagIndex = 0
      }
    }
  },
  computed: {},
  methods: {
    // 滑动跳转
    handleTouchstart (e) {
      if (this.flag) {
        this.startX = e.changedTouches[0].clientX
      }
    },
    handleTouchend (e) {
      if (this.flag) {
        const endX = e.changedTouches[0].clientX
        if (endX - this.startX > 100) {
          this.$router.push('/')
        }
      }
    },
    // 阻止页面刚进来就可以滑动跳转
    timesChange () {
      this.times = setInterval(_ => {
        this.flagIndex++
      }, 500)
    },
    // 折线图
    drawline () {
      this.myChart = echarts.init(document.getElementById('main'))
      const option = {
        grid: {
          top: '15%',
          left: '0',
          right: '5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          nameGap: 5,
          axisTick: {
            show: true
          },
          axisLabel: {
            interval: 0
          },
          axisLine: {
            lineStyle: {
              color: '#000'
            }
          }
        },
        yAxis: {
          type: 'value',
          boundaryGap: false,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#000'
            }
          },
          axisTick: {
            show: false
          }
        },
        series: [{
          name: 'Clouds',
          data: [],
          areaStyle: {
            normal: {}
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                [{
                  offset: 0,
                  color: '#4676DA'
                },
                {
                  offset: 0.5,
                  color: '#B4D2F6'
                },
                {
                  offset: 1,
                  color: '#FBFCFE'
                }])
            }
          },
          type: 'line'
        }]
      }
      this.myChart.setOption(option)
    },
    getDrawline (val) {
      const option = this.myChart.getOption()
      const name = []
      const data = []
      if (val.ids) {
        val.ids.forEach(item => {
          data.push(item)
        })
      }
      if (val.name) {
        val.name.forEach(item => {
          name.push(item)
        })
      }
      option.xAxis[0].data = data
      option.series[0].data = name
      this.myChart.setOption(option)
    },
    /**  刷新部分   */
    // 刷新
    async refresh () {
      this.show = true
      Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
        message: '刷新中...'
      })
      const that = this
      switch (this.carrier) {
        case '移动PB': that.czAxiosYDPb(); break
        case '联通': that.czAxiosLT(); break
        case '移动CT': that.czAxiosYDCT(); break
      }
    },

    // 充值后刷新
    czRefresh () {
      if (this.czType === 'success') {
        if (this.czOrcx !== 'liuliang') {
          this.czType = 'recharge'
          this.$store.commit('setType', 'recharge')
          const that = this
          switch (this.carrier) {
            case '移动PB': that.czAxiosYDPbCx(); break
            case '联通': that.czAxiosLT(); break
            case '移动CT': break
            // case '移动CT': that.czAxiosYDCT(); break
            default: that.refreshAxiosDX()
          }
        } else {
          this.$store.commit('setFindType', '')
          this.czOrcx = ''
          this.czType = 'recharge'
          this.$store.commit('setType', 'recharge')
          const that = this
          switch (this.carrier) {
            case '移动PB': that.czAxiosYDPb(); break
            case '联通': that.czAxiosLT(); break
            case '移动CT': break
            // case '移动CT': that.czAxiosYDCT(); break
            default: that.refreshAxiosDX()
          }
        }
      }
    },
    // 移动PB 充值同步函数
    async czAxiosYDPb () {
      const { data: res } = await api.yiDongPbCZ({ iccId: this.cardNum })
      if (res.code === 1) return this.getInitNum('shuaxin')
      this.refreshAxiosDX()
    },
    // 移动PB 查询同步函数
    async czAxiosYDPbCx () {
      const { data: res } = await api.yiDongPb({ iccId: this.cardNum })
      if (res.code === 1) return this.getInitNum('shuaxin')
      this.refreshAxiosDX()
    },
    // 新移动(移动CT 同步函数
    async czAxiosYDCT () {
      const { data: res } = await api.newYiDong({ eqpId: this.eqpId })
      if (res.code !== 1) return this.getInitNum('shuaxin')
      this.refreshAxiosDX()
    },
    // 联通 同步函数
    async czAxiosLT () {
      const { data: res } = await api.lianTong({ iccId: this.cardNum })
      if (res.code === 1) return this.getInitNum('shuaxin')
      this.refreshAxiosDX()
    },
    // 同步失败函数
    refreshAxiosDX () {
      let second = 3
      const timer = setInterval(_ => {
        second--
        if (second) return
        this.show = false
        clearInterval(timer)
        // 手动清除 Toast
        Toast.fail('刷新失败,请稍后重试')
      }, 1000)
    },

    /**  切换卡号部分   */
    // 切换卡号
    switchcardNum () {
      this.$router.push({ name: 'QueryRecharge' })
    },
    /**  充值部分   */
    xfBtn (ress) {
      const that = this
      chooseWXPay(ress.timeStamp, ress.nonceStr, ress.packageValue, ress.signType, ress.paySign, ress.appId).then(res => {
        // alert(res.errMsg)
        if (res.errMsg === 'chooseWXPay:ok') {
          // 调用查询商户接口
          that.$store.commit('setFlag', 'true')
          that.$router.push({
            name: 'Pay'
          })
        }
      }).catch(err => {
        // alert(err.errMsg)
        if (err.errMsg === 'chooseWXPay:cancel') return Toast('用户取消支付')
        if (err.errMsg === 'fail') return Toast('支付失败')
      })
    },
    // 充值
    // async recharge (e) {
    //   if (this.createdList.stateFlag === 567) {
    //     return this.$message.warning('此卡已进入注销流程，无法充值，请联系服务商更换新卡')
    //   }
    //   // if (this.createdList.storeName === '移动CT2') return Toast('功能开发中')
    //   if (e !== 'huoqu') {
    //     this.$store.commit('setOrder', '')
    //     this.$store.commit('setFindType', '')
    //     this.czIndex = 0
    //     const res = await api.rechargeSubmit({ iccid: this.cardNum })
    //     if (res.status !== 200 && res.statusText !== 'OK') return Toast.fail(res.data.msg)
    //     if (res.data.code !== 0) return Toast.fail(res.data.msg)
    //     this.orderId = res.data.extend.pay.id
    //     this.$store.commit('setOrder', this.orderId)
    //   }
    //   const { data: ress } = await api.payUnifiedOrderV2({
    //     payId: this.orderId,
    //     tradeType: 'JSAPI',
    //     openId: this.openid
    //   })
    //   if (ress.code !== 0) {
    //     return this.$toast(ress.msg)
    //   }
    //   if (!ress.extend.payData) {
    //     return this.$toast('订单获取失败，请稍后重试')
    //   }
    //   const payData = ress.extend.payData
    //   if ('payUrl' in payData) {
    //     window.location.href = payData.payUrl
    //     return
    //   } else if (!ress.appId || !ress.nonceStr || !ress.packageValue || !ress.paySign || !ress.signType || !ress.timeStamp) {
    //     if (this.czIndex > 4) {
    //       return Toast('支付失败，请稍后重试')
    //     }
    //     this.czIndex++
    //     return this.recharge('huoqu')
    //   }
    //   this.xfBtn(ress)
    // },
    // 流量
    // async updates (e) {
    //   if (this.createdList.storeName !== '江苏联通' && this.createdList.storeName !== '浙江联通' && this.createdList.storeName !== '移动CT1' && this.createdList.storeName !== '移动CT2' && this.createdList.storeName !== '移动CT3') return Toast('暂不支持叠加流量包')
    //   if (e !== 'huoqu') {
    //     this.$store.commit('setOrder', '')
    //     this.$store.commit('setFindType', 'liuliang')
    //     const { data: res } = await api.RechargeFlow({ iccid: this.cardNum })
    //     if (res.code !== 0 && res.msg !== '操作成功') return Toast.fail('充值失败')
    //     this.orderId = res.extend.pay.id
    //     this.$store.commit('setOrder', this.orderId)
    //   }
    //   const { data: ress } = await api.payUnifiedOrder({
    //     payId: this.orderId,
    //     tradeType: 'JSAPI',
    //     openId: this.openid
    //   })
    //   if (ress.code !== 0) {
    //     return this.$toast(ress.msg)
    //   }
    //   if (!ress.extend.payData) {
    //     return this.$toast('订单获取失败，请稍后重试')
    //   }
    //   const payData = ress.extend.payData
    //   if ('payUrl' in payData) {
    //     window.location.href = payData.payUrl
    //     return
    //   } else if (!ress.appId || !ress.nonceStr || !ress.packageValue || !ress.paySign || !ress.signType || !ress.timeStamp) {
    //     if (this.czIndex > 4) {
    //       return Toast('支付失败，请稍后重试')
    //     }
    //     this.czIndex++
    //     return this.updates('huoqu')
    //   }
    //   this.xfBtn(ress)
    // },
    async tochongzhi (e) {
      this.$router.push({ name: 'packageAdd', params: { iccid: this.cardNum } })
    },
    async toold (e) {
      window.location.href = 'http://wxold.qianbaokj.cn/recharge/qryindex?iccid=' + this.cardNum
    },
    /**  获取初始值部分   */
    // 获取初始值
    async getInitNum (type) {
      const that = this
      const { data: res } = await api.rechargeList({ iccid: this.cardNum })
      if (res.code === 1) {
        this.$router.push({ name: 'QueryRecharge' })
        return this.$toast.fail(res.msg)
      }
      this.createdList = res
      this.carrier = res.carrier
      this.storeName = res.storeName
      this.eqpId = res.eqpId
      if (res.carrier === '联通') {
        this.cardNum = res.iccid
        this.$store.commit('setIccd', this.cardNum)
      }
      if (type === 'chushihua') {
        this.showLogin = false
        Toast.clear()
      }
      if (this.createdList.status === '已激活') {
        this.$set(this.createdList, 'stateFlag', 3)
      } else if (this.createdList.status === '待激活') {
        this.$set(this.createdList, 'stateFlag', 2)
      } else if (this.createdList.status === '已停机') {
        this.$set(this.createdList, 'stateFlag', 4)
      } else {
        this.$set(this.createdList, 'stateFlag', 567)
      }
      // this.createdList.flow = this.createdList.remainFlow ? this.createdList.remainFlow : ''
      if (type === 'shuaxin') {
        Toast.success('刷新成功，请开关机')
        this.show = false
      }
      this.timesChange()
      that.czRefresh()
      Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
        message: '获取数据中...'
      })
      // 移动调用数据库（官方接口不稳定），联通调用官方接口
      var ress = {}
      if (this.carrier === '移动CT') {
        ress = await api.billList(this.eqpId).then(res => {
          var ids = ['1月', '2月', '3月', '4月', '5月', '6月']
          var names = res.data.extend.rows.map(item => { return item.flow })
          var months = res.data.extend.rows.map(item => {
            if (item.month !== '-1') {
              if (item.month.substring(item.month.length - 2, item.month.length - 1) === '0') {
                return item.month.substring(item.month.length - 1, item.month.length) + '月'
              } else {
                return item.month.substring(item.month.length - 2, item.month.length) + '月'
              }
            } else {
              return new Date().getMonth() + 1 + '月'
            }
          })
          months.reverse()
          ids = months
          // 前端固定显示6个，因此放入6个在截取后6个，防止数据null
          names.reverse()
          if (ids.length > 6) {
            ids = ids.slice(ids.length - 6, ids.length)
            names = names.slice(names.length - 6, names.length)
          }
          var data = {
            ids: ids,
            name: names
          }
          return data
        })
      } else {
        ress = await api.getLineChart({ iccid: this.cardNum }).then(res => {
          return res.data
        })
      }
      Toast.clear()
      const drawlineList = JSON.parse(JSON.stringify(ress))
      this.getDrawline(drawlineList)
      if (type === 'chushihua' && this.openid !== '') {
        switch (res.carrier) {
          case '移动PB': await api.yiDongPb({ iccid: this.cardNum }); break
          case '联通': await api.lianTong({ iccid: this.cardNum }); break
          case '移动CT': await api.newYiDong({ eqpId: this.eqpId }); break
        }
        if (res.storeName === '移动CT2') {
          await api.YDCTReact({ eqpId: this.eqpId })
        }
        const { data: ress } = await api.rechargeList({ iccid: this.cardNum })
        this.dbIndex = 0
        for (const key in ress) {
          if (ress[key] !== this.createdList[key]) {
            this.dbIndex++
            this.$set(this.dbForm, key, ress[key])
          }
        }
        if (this.dbIndex > 5) {
          window.location.reload(true)
        } else {
          for (const key in this.dbForm) {
            this.createdList[key] = this.dbForm[key]
          }
        }
      }
      if (res.offReason === 1) {
        Toast('机卡分离停机，请联系服务商')
      } else if (res.offReason === 101) {
        Toast('停机复通，请联系服务商')
      }
    },
    async gotoAuth () {
      const { data: ress } = await api.authorize({
        returnUrl: location.href,
        state: this.cardNum
      })
      if (ress !== '获取失败') {
        location.href = ress
      }
    },
    async getInfo (code) {
      const { data: ress } = await api.getUserInfo({
        code: code
      })
      if (ress.indexOf('获取失败') < 0) {
        this.openid = ress
        this.$store.commit('setOpenId', ress)
        this.$store.commit('setVersionTime', new Date().getTime())
        this.$store.commit('setIsFirst', '1')
        this.getconfig()
      }
    },
    async getconfig () {
      const urlThis = location.href.split('#')[0]
      const { data: ress } = await api.rechargeList({ iccid: this.cardNum })
      if (ress.carrier === '联通') {
        this.cardNum = ress.iccid
      }
      // if (urlThis.split('?').length > 1) {
      //   const newData = +new Date()
      //   this.thisURL = urlThis.split('?')[0] + '#/Recharge/' + this.cardNum + '?' + newData
      //   window.location.href = this.thisURL
      //   return
      // }
      const { data: res } = await initConfig({
        url: urlThis
      })
      if (res) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          jsApiList: [
            'chooseWXPay'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      }
    },
    getQueryString (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      const result = window.location.search.substring(1).match(reg)
      if (result != null) {
        return decodeURIComponent(result[2])
      }
      return null
    },
    getFindeOpenId () {
      if (this.isFirst === '' && this.getQueryString('code') == null) {
        this.$store.commit('setOpenId', '')
        this.gotoAuth()
        return
      }
      if (this.openid === '') {
        if (this.getQueryString('code') == null) {
          this.gotoAuth()
        } else {
          this.getInfo(this.getQueryString('code'))
        }
      } else {
        this.getconfig()
      }
      this.getInitNum('chushihua')
    }
  },
  beforeCreate () {
  },
  created () {
    const that = this
    // const Timestamp = new Date().getTime()
    getAppEdition().then(({ data: res }) => {
      const Timestamp = new Date().getTime()
      if (!localStorage.getItem('AppEdition') || localStorage.getItem('AppEdition') !== res.version) {
        localStorage.setItem('AppEdition', res.version)
        localStorage.setItem('OPENID', '')
        that.$store.commit('setOpenId', '')
        const iccid = this.$route.params.iccid
        location.href = process.env.VUE_APP_DOMAIN + '?Edition=' + Timestamp + '/#/Recharge/' + iccid
      }
    }).then(res => {
      this.showLogin = true
      Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
        message: '获取数据中...'
      })
      this.cardNum = this.$route.params.iccid
      this.czType = this.$store.state.type ? this.$store.state.type : 'recharge'
      this.czOrcx = this.$store.state.findType ? this.$store.state.findType : ''
      this.openid = this.$store.state.openId ? this.$store.state.openId : ''
      this.isFirst = this.$store.state.isFirst ? this.$store.state.isFirst : ''
      this.$store.commit('setIccd', this.cardNum)
      // this.getInitNum('chushihua')
      this.getFindeOpenId()
    })
  },
  mounted () {
    this.drawline()
  }
}
</script>

<style scoped lang='less'>
  .home{
    height: 100%;
    .banner {
      height: 100%;
      position: absolute;
      top: -60px;
      left: 0;
      z-index: -1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      background-color: #eee;
      img {
        width: 100%;
        display: block;
      }
    }
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 57px 47px 0;
      .contentss {
        position: relative;
        display: flex;
        justify-content: space-between;
        width: 100%;
        .left {
          height: 100%;
          color: #ffff;
          font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif;
          .text {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            color: #fff;
            h3 {
              font-size: 30px;
              font-weight: 400;
            }
            .left_bottom {
              display: flex;
              justify-content: flex-start;
              margin-top: 20px;
              text-align: left;
              font-size: 25px;
              .texts {
                display: flex;
              }
              .leftText {
                margin-right: 20px;
              }
              .ztqk {
                display: flex;
                align-items: baseline;
                i {
                  display: block;
                  width: 14px;
                  height: 13px;
                  background-color: #01e23b;
                  border-radius:50%;
                  margin: 0 16px;
                  margin-left: 11px;
                }
              }
              .isWait { // 2
                background-color: rgb(250, 192, 0)!important;
                border-color: rgb(250, 192, 0);
              }
              .isOk { // 3
                background-color: #01e23b!important;
                border-color: #01e23b;
              }
              .isNo { // 4
                background-color: red!important;
                border-color: red;
              }
              .isOut { // 567
                background-color: #393e46!important;
                border-color: #393e46;
              }
            }
          }
        }
        .right {
          width: 221px;
          height: 221px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif;
          .right_ll {
            font-size: 28px;
            .spanMB {
              font-size: 15px;
            }
          }
          .right_text {
            font-size: 15px;
          }
          img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
          }
        }
      }
    }
    nav {
      background-color: transparent;
      ul {
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        margin: 0 24px;
        font-size: 26px;
        background-color: #FFFFFF;
        border-radius: 20px;
        margin-top: 20px;
        list-style: none;
        font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif;
        li {
          flex: 1;
          padding: 14px 30px;
          display: flex;
          align-items: flex-end;
        }
        li:first-child {
          border-right: 2px solid #E6E6E6;
        }
      }
    }
    .content {
      background-color: #eee;
      font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif;
      .tc {
        font-size: 26px;
        padding: 18px 24px;
        font-weight: 400;
      }
      .idmain {
        margin: 2px 24px 0;
        padding: 36px;
        height: 390px;
        background: #FFFFFF;
        border-radius: 20px;
      }
      h5 {
        font-size: 25.1px;
        padding: 18px 24px;
        // padding: 20px 24px;
        font-weight: 400;
      }
      .nav {
        user-select: none;
        margin: 0 24px;
        font-size: 23px;
        padding: 5px 0;
        // padding: 15px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #FFFFFF;
        border-radius: 20px;
        .lis {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px 20px;
          // padding: 16px 20px;
          flex: 1;
          white-space: nowrap;
          cursor: pointer;
          font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif;
          img {
            width: 35px;
            height: 35px;
            // width: 45px;
            // height: 45px;
            margin-right: 10px;
          }
          h3 {
            font-weight: 400;
          }
        }
        .shu {
          width: 2.1px;
          height: 36.94px;
          // height: 76.94px;
          background: url(../../assets/shu.png) no-repeat;
          background-size: 100%;
          background-position: center;
        }
      }
    }
    footer {
      background-color: #eee;
      font-size: 25px;
      padding: 24px;
      p {
        color: #969696;
      }
    }
    .btnbox {
      background-color: #eee;
      padding-bottom: 48.75px;
      // padding-bottom: 80px;
      button {
        display: block;
        border-radius: 40px;
        background: linear-gradient(-45deg, #426EDA, #34A0F4);
        width: 626px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-size: 28px;
        color: #fff;
        margin: 0 auto;
        border: none;
      }
    }
  }
  .van-overlay {
    background-color: rgba(255, 255, 255,0.7);
  }
  .loginOverLay {
    background-color: #fff!important;
  }
</style>
